import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
  label?: string
  name?: string
}

const Postcode = ({
  name: inputName,
  label: inputLabel,
  helper,
  ...rest
}: Props) => {
  const name = inputName || 'postcode'
  const label = inputLabel || 'Postcode'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default Postcode
